import {ROUTES} from '@/config/constants'
// import {AuthContext} from '@/helpers/Auth/AuthProvider'
import {UserRoleContext, UserRoleProvider} from '@/helpers/UserRole/UserRoleProvider'
import {useAuth} from '@/hooks/useAuth'
import {Template} from '@/pages/Template'
import {useContext, useEffect} from 'react'
import {Outlet, useNavigate} from 'react-router-dom'

export const ProtectedRoutes = () => {
  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  )
}

const ProtectedRoutesContent = () => {
  const {isAuthenticated, signInWithRedirect, inProgress, isCypress} = useAuth()
  const {isAuthorized, isReady: isUserRoleReady, error: userRoleError} = useContext(UserRoleContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (!isCypress && !isAuthenticated && inProgress === 'none') {
      signInWithRedirect()
      // navigate(ROUTES.LOGIN)
      return
    }

    if (userRoleError) {
      navigate(ROUTES.ERROR_500)
      return
    }

    if (isUserRoleReady && !isAuthorized) {
      navigate(ROUTES.ERROR_403)
    }
  }, [
    isAuthenticated,
    isAuthorized,
    isUserRoleReady,
    navigate,
    userRoleError,
    signInWithRedirect,
    inProgress,
    isCypress,
  ])

  const canRenderRoute = isCypress || (isAuthenticated && isAuthorized)

  return canRenderRoute ? <Outlet /> : null
}
